import type { ProfileDetailsResponse } from '@/core/api/models/profile';
import { useAppStore } from '@/core/stores/appStore';
import { useEffect } from 'react';
import { mapProfileDetailsToUserPatch } from '../services/profileService';

/** Write a successful GET /v1/customers/profile-details response onto auth.user. */
export function useSyncProfileDetailsToStore(
  profileData: ProfileDetailsResponse | undefined,
  isSuccess: boolean,
): void {
  const setProfile = useAppStore((state) => state.setProfile);

  useEffect(() => {
    if (!isSuccess || !profileData) {
      return;
    }
    setProfile(mapProfileDetailsToUserPatch(profileData));
  }, [isSuccess, profileData, setProfile]);
}
